import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { css } from '@emotion/css';
import { observer } from 'mobx-react-lite';
import { useDrawerData } from '../DrawerProvider';
import { DrawerThumbnailAssetProvider, DrawerThumbnailButton, DrawerThumbnailFluidImage, DrawerThumbnailInUseIcon, DrawerThumbnailRenderWrapper, } from './Components';
import { getThumbnailStyle } from './DrawerThumbnailStyles';
const multiPageThumbnailButtonStyle = css `
    margin: auto;
    float: unset;
`;
export const DrawerThumbnailMultiPage = observer((props) => {
    const { asset, pageNumber, onClick, onDoubleClick } = props;
    const { styleOptions } = useDrawerData();
    return (_jsx(DrawerThumbnailAssetProvider, Object.assign({ asset: asset, pageNumber: pageNumber }, { children: _jsx(DrawerThumbnailRenderWrapper, Object.assign({ isMultiPage: true }, { children: _jsx("div", Object.assign({ className: getThumbnailStyle({ isMultiPage: true, styleOptions }) }, { children: _jsxs(DrawerThumbnailButton, Object.assign({ className: multiPageThumbnailButtonStyle, onClick: onClick, onDoubleClick: onDoubleClick }, { children: [_jsx(DrawerThumbnailFluidImage, {}), _jsx(DrawerThumbnailInUseIcon, {})] })) })) })) })));
});
//# sourceMappingURL=DrawerThumbnailMultiPage.js.map